import styled from "styled-components"
import { BlogThreshold as Threshold } from '../../constants/theme'

export const TimelineSlider = styled.div`
  position: relative;
  
  max-width: min(80vw, 2005px);
  margin: 0 auto;

  @media (max-width: ${Threshold.tablet}) {
    max-width: 85vw;
    margin-bottom: 150px;

    .swiper {
      padding-top: 150px;
    }
  }

  @media (max-width: ${Threshold.phone}) {
    width: 100%;
    max-width: none;
    margin-bottom: 0;
  }

  .swiper-button-prev,
  .swiper-button-next {
    top: calc(45% - 19px);
    
    width: 42px;
    height: 42px;

    outline: 0;
    border: 2px solid #933ec5;
    border-radius: 50%;
    
    background-color: #fff;
    color: #933ec5;
    font-weight: 700;
    
    transition: background-color 0.2s ease, color 0.2s ease;

    &::after {
      position: absolute;
      font-size: 16px;
    }

    :hover {
      color: #fff;
      background-color: #933ec5;
    }
  }

  @media (max-width: ${Threshold.tablet}) {
    .swiper-button-prev,
    .swiper-button-next {
      top: 288px;
      -webkit-tap-highlight-color: transparent;
    }
  }

  .swiper-button-prev {
    ::after {
      left: calc(50% - 5px);
    }
  }
  .swiper-button-next {
    ::after {
      left: calc(50% - 3px);
    }
  }
  .swiper-button-disabled {
    /* TODO: Мб стоит убрать */
    opacity: 0;
  }
`

export const DesktopWrapper = styled.div`
  @media (max-width: ${Threshold.phone}) {
    display: none;
  }
`

export const MobileWrapper = styled.div`
  display: none;

  @media (max-width: ${Threshold.phone}) {
    display: block;
  }
`
